const event = window._event || getFromLocation(/\/([0-9]+)\/$/);
const thanksUuid = window._uuid || getFromLocation(/\/([a-zA-Z0-9\-]+)\/thanks\/$/);

function resetForm() {
    $('.events-body form').each((i, el) => {
        el.reset()
    });
}

// Reset the form on load to prevent people hitting back from having a dirty form
resetForm();
window.addEventListener('pageshow', resetForm);

window.addEventListener('focus', getCheckinData)

function getFromLocation(reg) {
    const find = window.location.href.match(reg);
    if (find && find.length > 1) {
        return find[1];
    }
    return null;
}

function getLocalStorageKey() {
    return `uuid-${event}`;
}

function getUuids() {
    const uuids = localStorage.getItem(getLocalStorageKey());
    try {
        return JSON.parse(uuids || '[]');
    } catch (e) {
        return [];
    }
}

function saveUuids(uuids) {
    localStorage.setItem(getLocalStorageKey(), JSON.stringify(uuids));
}

function addUuid(uuid) {
    if (uuid) {
        const uuids = getUuids();
        if (uuids.indexOf(uuid) < 0) {
            uuids.push(uuid);
        }
        saveUuids(uuids);
    }
}

function addCheckin(checkins) {
    if (!checkins || !checkins.length) {
        return;
    }

    $('#day-after-checkin').addClass('d-none');

    const $ac = $('#additional-checkins');

    $ac.html(`
        <p class="mt-2 font-weight-bold">
            Would you like to check-in:
        </p>
        <ul class="list-group list-group-flush">
            ${checkins.map(c => `
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>${c.first_name} ${c.last_name}</span>
                    <a class="btn btn-link" href="/workshops/check-in/${c.uuid}/thanks/">Check-In</a>
                </li>
            `).join('')}
        </ul>
    `);

    $ac.removeClass('d-none');
}

function getCheckinData() {
    $.ajax({
        method: 'post',
        url: '/workshops/check-in/lookup/',
        data: { event, uuids: JSON.stringify(getUuids()), csrfmiddlewaretoken: $('[name="csrfmiddlewaretoken"]').val() }
    }).then(data => {
        try {
            const d = new Date();
            const today = `${d.getUTCFullYear()}-${`00${d.getUTCMonth() + 1}`.slice(-2)}-${`00${d.getUTCDate()}`.slice(-2)}`;
            const checkinData = JSON.parse(data);
            const addCheckins = [];
            for (const checkin of checkinData) {
                if (checkin.checkins.indexOf(today) < 0) {
                    addCheckins.push(checkin);
                }
            }

            addCheckin(addCheckins);
        } catch (e) {}
    });
}

addUuid(thanksUuid);
getCheckinData();
